module.exports = __webpack_public_path__ + "images/speed-eight-default.6c192a7a69f80b716f90dc374d7d8c8a.png";